import type { ProjectName } from '@/app/projects/types';

export type DetailsMap = Partial<Record<ProjectName, string[]>>;

const DETAILS_MAP: DetailsMap = {
  Hazel: ['2,800 Sq. Ft.', '3 Bedrooms', '2.5 Baths'],
  'River Ranch': ['2,000 Sq. Ft.', '3 Bedrooms', '2 Baths'],
  Sellers: ['2,500 Sq. Ft.', '3 Bedrooms', '3.5 Baths'],
  Sparrow: ['6,000 Sq. Ft.', '6 Bedrooms', '4 Baths'],
  Willow: ['3,500 Sq. Ft.', '3 Bedrooms', '3.5 Baths'],
  Ling: ['1,230 Sq. Ft.', '3 Bedrooms', '2 Baths'],
  Geranium: ['', '1 Bedroom', '1 Bath'],
};

export default DETAILS_MAP;
